import React, { useContext } from 'react';
import DocumentAuthorContext from '../../../../../context/DocumentAuthorContext';

function SelectBox({component}){
    const { componentAnswers } = useContext(DocumentAuthorContext);
    return (
        <div className={`${component.label.alignment === 'top' ? 'flex flex-col' : 'flex items-center'}`}>
            {component.label.name.trim() !== '' && 
            <label className={`pr-2 break-all`} style={component?.label?.styles}>
                {component.label.name || ''} {component.is_required && <span data-testid="is_required" className='text-[#333]'>*</span>}
            </label>}
            <>
                <button
                    data-testid="select-box-input"
                    className={`border border-[#D7D7D7]
                    rounded-lg px-3 py-4 flex justify-between items-center  font-normal text-sm mt-1 text-[#797979]
                outline-0`}
                    style={component.styles}
                    type="button" aria-expanded="false">
                    <span className='flex items-start justify-start text-truncate'>
                        {component?.value || componentAnswers[component.component_id] || component?.placeholder?.name || ''}
                    </span>
                </button>
            </>
        </div>
    )
}

export default SelectBox